import { CsvDataExporter } from './csv-data-exporter';
import { XlsDataExporter } from './xls-data-exporter';

export class DataExporterFactory {
  static get(format: string) {
    if (format === 'csv') {
      return new CsvDataExporter();
    }

    if (format === 'xls' || format === 'xlsx') {
      return new XlsDataExporter();
    }

    throw new Error(`Data exporter for format ${format} not implemented`);
  }
}
